/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkIcp } from "../../funcs/networkGetNetworkIcp.js";
import { GetNetworkIcpRequest$zodSchema } from "../../models/getnetworkicpop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkIcpRequest$zodSchema,
};

export const tool$networkGetNetworkIcp: ToolDefinition<typeof args> = {
  name: "network-get-network-icp",
  description: `查询域名ICP备案信息

想知道一个网站的背后运营主体是谁吗？如果它是在中国大陆运营的，ICP备案信息可以告诉你答案。

## 功能概述
提供一个域名，查询其在中国工信部的ICP（Internet Content Provider）备案信息。这对于商业合作前的背景调查、验证网站合法性等场景很有帮助。

> [!NOTE]
> **查询范围**
> 此查询仅对在中国大陆工信部进行过备案的域名有效。对于国外域名或未备案的域名，将查询不到结果。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkIcp(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
